import { render, staticRenderFns } from "./updatecar.vue?vue&type=template&id=05c05d5c"
import script from "./updatecar.vue?vue&type=script&lang=js"
export * from "./updatecar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports